module.exports = __webpack_public_path__ + "img/apex to apex.d49952bc.png";